module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GG-9a9e11d667215fd65f86bb853d4f8068.png";